import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Football = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7-66 24.5-112.2 66.5-142.9 116.5-18.3 29.8-30.9 62.3-39.2 95.4l237.7 237.6c13.5-3.3 26.4-7.2 38.6-11.7 66-24.5 112.2-66.5 142.9-116.5 18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zm247.7 179.9c6.1-56.8 1.4-112.2-7.7-156.4-2.7-12.9-13-22.9-26.1-25.1-58.2-9.7-109.9-12-155.6-7.9l189.4 189.4zM206.1 496 16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4 2.7 12.9 13 22.9 26.1 25.1 58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
  }));
});
Football.displayName = 'Football';
export var FootballDimensions = {
  height: 512,
  width: 512
};